import { Badge } from "@chakra-ui/react";
import type { TaskStatus } from "types/fulfillment";
import { getStatusLabel } from "utils/taskStatus";

const scheme: Record<TaskStatus, string> = {
  new: "orange",
  preparing: "blue",
  shipped: "purple",
  delivered: "green",
  cancelled: "red",
};

export function OrderStatusBadge({ status }: { status: TaskStatus }) {
  return (
    <Badge
      colorScheme={scheme[status] ?? "gray"}
      borderRadius="full"
      px={2.5}
      py={0.5}
      fontSize="xs"
      fontWeight="medium"
    >
      {getStatusLabel(status)}
    </Badge>
  );
}
